import script from "./WindRadarUI.vue?vue&type=script&setup=true&lang=ts"
export * from "./WindRadarUI.vue?vue&type=script&setup=true&lang=ts"

import "./WindRadarUI.vue?vue&type=style&index=0&id=6a750413&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a750413"]])

export default __exports__